import template from './loading.html';
import './loading.less';
import LoadingController from './loading.controller';

const LoadingComponent = {
  bindings: {
    marginTop: '@'
  },
  template,
  controller: LoadingController
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/loading/loading.component.js